import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const TelegramAccountClientTradersServiceContext = createContext(undefined)

const TelegramAccountClientTradersServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={TelegramAccountClientTradersServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/telegram/account_client_traders${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        update: async (payload) => {
          const {data} = await axios.patch(`/api/v1/telegram/account_client_traders`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

TelegramAccountClientTradersServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useTelegramAccountClientTradersService = () => {
  const context = useContext(TelegramAccountClientTradersServiceContext)
  if (context === undefined) {
    throw new Error('TelegramAccountClientTradersServiceContext was not provided. Make sure your component is a child of the TelegramAccountClientTradersServiceProvider.')
  }
  return context
}

const useTelegramAccountClientTradersQuery = ({query, ...otherProps}) => {
  const telegramAccountClientTradersService = useTelegramAccountClientTradersService()
  return useSimpleQuery({
    queryKey: `telegram_account_client_traders-list-${JSON.stringify(query)}`,
    queryFn: async () => telegramAccountClientTradersService.list(query),
    ...otherProps
  })
}

export {TelegramAccountClientTradersServiceProvider, useTelegramAccountClientTradersService, useTelegramAccountClientTradersQuery}
